(function(){
  'use strict';
  var HOME_LIMIT = 5; /* згорнутий вид: макс. 5 слайдів, решта — в Explore */
  function initSliders(){
    document.querySelectorAll('[data-e3c-slider]').forEach(function(root){
      if(root.dataset.e3cInit) return;
      root.dataset.e3cInit='1';
      var track=root.querySelector('[data-e3c-track]');
      if(!track) return;
      var n=track.children.length, i=0, timer=null;
      var counters=root.querySelectorAll('[data-e3c-count]');
      var quotes=root.querySelectorAll('[data-e3c-qitem]');
      var capped=root.hasAttribute('data-e3c-cap');
      function isCapped(){ return capped&&!root.classList.contains('is-full')&&n>HOME_LIMIT; }
      function lim(){ return isCapped()?HOME_LIMIT:n; }
      function go(k){
        var L=lim();
        i=((k%L)+L)%L;
        track.style.transform='translateX(-'+(i*100)+'%)';
        var label=isCapped()?L+'+':L;
        counters.forEach(function(c){c.textContent=(i+1)+' / '+label;});
        quotes.forEach(function(q,idx){q.classList.toggle('is-active',idx===i);});
      }
      function stop(){ if(timer){clearInterval(timer);timer=null;} }
      root.__e3cRefresh=function(){ go(i); };
      root.querySelectorAll('[data-e3c-prev]').forEach(function(b){b.addEventListener('click',function(){stop();go(i-1);});});
      root.querySelectorAll('[data-e3c-next]').forEach(function(b){b.addEventListener('click',function(){stop();go(i+1);});});
      /* свайп пальцем — гортає слайд+цитату (і згорнутий, і Explore-вид) */
      var sx=0, sy=0, swiping=false;
      root.addEventListener('touchstart',function(e){
        if(!e.target.closest('[data-e3c-track]')&&!e.target.closest('[data-e3c-qitem]')) { swiping=false; return; }
        if(e.touches.length!==1){ swiping=false; return; }
        sx=e.touches[0].clientX; sy=e.touches[0].clientY; swiping=true;
      },{passive:true});
      root.addEventListener('touchend',function(e){
        if(!swiping) return; swiping=false;
        var t=e.changedTouches[0];
        var dx=t.clientX-sx, dy=t.clientY-sy;
        if(Math.abs(dx)>50&&Math.abs(dx)>1.5*Math.abs(dy)){ stop(); go(dx<0?i+1:i-1); }
      },{passive:true});
      var ap=parseFloat(root.getAttribute('data-e3c-autoplay')||'0');
      if(ap>0&&n>1){ timer=setInterval(function(){go(i+1);},ap*1000); }
      go(0);
    });
  }
  function toBody(id){
    var el=document.getElementById(id);
    if(el&&el.parentNode!==document.body){ document.body.appendChild(el); }
    return el;
  }
  function videoId(){
    var vm=document.getElementById('ErasVideoModal');
    return (vm&&vm.getAttribute('data-video-id'))||'iJO8jWsKObA';
  }
  var demoStarted=false;
  function nativeVideo(){ return document.querySelector('[data-e3c-poster] video'); }
  function playNative(v){
    var p=v.closest('[data-e3c-poster]');
    if(p) p.classList.add('is-playing');
    v.controls=true;
    v.play();
  }
  function setExpanded(on){
    var p=document.querySelector('[data-e3c-poster]');
    var b=document.getElementById('ErasVBackdrop');
    if(!p) return;
    p.classList.toggle('is-expanded',on);
    document.body.classList.toggle('e3c-vx',on);
    if(b) b.classList.toggle('is-open',on);
    document.body.style.overflow=on?'hidden':'';
    var x=p.querySelector('[data-e3c-expand]');
    if(x) x.textContent=on?'⤡':'⤢';
  }
  function isExpanded(){
    var p=document.querySelector('[data-e3c-poster]');
    return !!(p&&p.classList.contains('is-expanded'));
  }
  function mountDuo(sec){
    if(sec.id!=='eras-03') return;
    var duo=document.getElementById('ErasDuoHost');
    if(!duo) return;
    if(!duo.__home) duo.__home=duo.parentNode;
    sec.appendChild(duo);
    duo.style.display='block';
  }
  function unmountDuo(sec){
    var duo=sec.querySelector('#ErasDuoHost');
    if(duo&&duo.__home){ duo.__home.appendChild(duo); duo.style.display='none'; }
  }
  function mountFooter(sec){
    if(sec.querySelector('.e3c-x-footer')) return;
    var f=document.querySelector('footer.e3c-footer');
    if(!f) return;
    var c=f.cloneNode(true);
    c.classList.add('e3c-x-footer');
    sec.appendChild(c);
  }
  function unmountFooter(sec){
    var c=sec.querySelector('.e3c-x-footer');
    if(c) c.remove();
  }
  function expandSec(sec){
    if(!sec||sec.classList.contains('is-full')) return;
    sec.classList.add('is-full');
    sec.scrollTop=0;
    document.body.style.overflow='hidden';
    mountDuo(sec);
    mountFooter(sec);
    if(sec.__e3cRefresh) sec.__e3cRefresh();
  }
  function collapseSections(){
    var any=false;
    document.querySelectorAll('.e3c-sec-in.is-full').forEach(function(s){
      unmountDuo(s);
      unmountFooter(s);
      s.classList.remove('is-full');any=true;
      if(s.__e3cRefresh) s.__e3cRefresh();
    });
    if(any) document.body.style.overflow='';
    return any;
  }
  /* #<anchor>-explore — скрол до секції + одразу відкритий Explore */
  function resolveAnchor(id){
    var el=document.getElementById(id);
    if(el) return {el:el,explore:false};
    if(/-explore$/.test(id)){
      var base=document.getElementById(id.replace(/-explore$/,''));
      if(base) return {el:base,explore:true};
    }
    return null;
  }
  function openVideo(){
    var nv=nativeVideo();
    if(nv){ playNative(nv); return; }
    if(window.matchMedia('(max-width:1100px)').matches){
      var p=document.querySelector('.e3c-poster');
      if(p){
        if(!p.querySelector('iframe')){
          var fi=document.createElement('iframe');
          fi.src='https://www.youtube.com/embed/'+videoId()+'?autoplay=1&playsinline=1&rel=0&modestbranding=1';
          fi.allow='autoplay; encrypted-media; fullscreen';
          fi.setAttribute('allowfullscreen','');
          fi.setAttribute('playsinline','');
          fi.style.cssText='position:absolute;inset:0;width:100%;height:100%;border:0;z-index:4;background:#000';
          p.appendChild(fi);
        }
        return;
      }
    }
    var vm=toBody('ErasVideoModal');
    if(!vm){ window.open('https://youtu.be/'+videoId(),'_blank'); return; }
    vm.classList.add('is-open');
    document.body.style.overflow='hidden';
    var frame=vm.querySelector('[data-e3c-vm-frame]');
    if(frame&&!frame.querySelector('iframe')){
      var f=document.createElement('iframe');
      f.src='https://www.youtube.com/embed/'+videoId()+'?autoplay=1&rel=0&modestbranding=1';
      f.allow='autoplay; encrypted-media; fullscreen';
      f.setAttribute('allowfullscreen','');
      frame.appendChild(f);
    }
  }
  function closeVideo(){
    var vm=document.getElementById('ErasVideoModal');
    if(!vm) return;
    vm.classList.remove('is-open');
    document.body.style.overflow='';
    var frame=vm.querySelector('[data-e3c-vm-frame]');
    if(frame) frame.innerHTML='';
  }
  /* 3C: аудіо-перехоплювача НЕМАЄ і не буде — гра сама керує звуком за розміром вікна (HANDOFF_ShopifyDeploy). Оверлей лише показує/ховає iframe; inline-стилі нижче — страховка від CSS-конфліктів з Motion (баг «scale застряг на бульці») */
  function openDemo(){
    var o=toBody('ErasDemoOverlay');
    if(!o) return;
    var body=o.querySelector('.e3c-demo-body');
    var tpl=o.querySelector('[data-e3c-demo-tpl]');
    if(body&&tpl&&!body.querySelector('iframe')){ body.appendChild(tpl.content.cloneNode(true)); }
    o.classList.add('is-open');
    o.style.transform='scale(1)';
    o.style.opacity='1';
    o.style.pointerEvents='auto';
    o.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    demoStarted=true;
  }
  function hideDemo(){
    var o=document.getElementById('ErasDemoOverlay');
    if(!o) return;
    o.classList.remove('is-open');
    o.style.transform='';
    o.style.opacity='';
    o.style.pointerEvents='';
    o.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
  }
  function smoothTo(el){
    if(el.classList&&el.classList.contains('e3c-acc')&&!el.classList.contains('is-open')) el.classList.add('is-open');
    var y=el.getBoundingClientRect().top+window.pageYOffset-64;
    window.scrollTo({top:y,behavior:'smooth'});
  }
  document.addEventListener('click',function(e){
    if(!e.target||!e.target.closest) return;
    var a=e.target.closest('a[href*="#"]');
    if(!a) return;
    var href=a.getAttribute('href')||'';
    var hi=href.indexOf('#');
    if(hi<0) return;
    var id=href.slice(hi+1);
    if(!id) return;
    var path=href.slice(0,hi).replace(/\/+$/,'');
    var cur=location.pathname.replace(/\/+$/,'');
    if(path&&path.indexOf('http')===0){
      try{ var u=new URL(href); if(u.origin!==location.origin) return; path=u.pathname.replace(/\/+$/,''); }catch(err){ return; }
    }
    if(path&&path!==cur) return;
    var r=resolveAnchor(id);
    if(!r) return;
    e.preventDefault();
    if(e.stopImmediatePropagation) e.stopImmediatePropagation(); else e.stopPropagation();
    collapseSections(); closeVideo(); hideDemo(); setExpanded(false);
    var mn=document.getElementById('ErasMobileNav');
    if(mn) mn.classList.remove('is-open');
    try{ history.replaceState(null,'',href); }catch(err){}
    smoothTo(r.el);
    if(r.explore&&r.el.classList.contains('e3c-sec-in')){ setTimeout(function(){ expandSec(r.el); },300); }
  },true);
  window.addEventListener('load',function(){
    if(location.hash){
      var r=resolveAnchor(location.hash.slice(1));
      if(r) setTimeout(function(){
        smoothTo(r.el);
        if(r.explore&&r.el.classList.contains('e3c-sec-in')) setTimeout(function(){ expandSec(r.el); },300);
      },250);
    }
  });
  document.addEventListener('click',function(e){
    if(!e.target||!e.target.closest) return;
    /* акордеони (Партнерам / Хто ми) */
    var accT=e.target.closest('[data-e3c-acc-toggle]');
    if(accT&&!e.target.closest('a')){ var acc=accT.closest('.e3c-acc'); if(acc) acc.classList.toggle('is-open'); return; }
    if(e.target.closest('[data-e3c-expand-sec]')){ expandSec(e.target.closest('.e3c-sec-in')); return; }
    if(e.target.closest('[data-e3c-collapse-sec]')){ collapseSections(); return; }
    var gs=e.target.closest('.e3c-gSlide');
    if(gs&&!e.target.closest('button')&&!e.target.closest('a')){
      var sec=gs.closest('.e3c-sec-in');
      if(sec&&!sec.classList.contains('is-full')&&sec.querySelector('[data-e3c-expand-sec]')){ expandSec(sec); return; }
    }
    if(e.target.closest('[data-e3c-expand]')){ setExpanded(!isExpanded()); return; }
    if(e.target.closest('[data-e3c-vcollapse]')){ setExpanded(false); return; }
    if(e.target.closest('[data-e3c-video-open]')){ e.preventDefault(); openVideo(); return; }
    if(e.target.closest('[data-e3c-vm-close]')){ closeVideo(); return; }
    if(e.target.closest('[data-e3c-demo-open]')){ e.preventDefault(); openDemo(); return; }
    if(e.target.closest('[data-e3c-demo-hide]')){ hideDemo(); return; }
    if(e.target.closest('[data-e3c-burger]')){ var m=toBody('ErasMobileNav'); if(m) m.classList.add('is-open'); return; }
    if(e.target.closest('[data-e3c-mnav-close]')||e.target.closest('.e3c-mnav a')){ var m2=document.getElementById('ErasMobileNav'); if(m2) m2.classList.remove('is-open'); }
    var langBtn=e.target.closest('[data-e3c-lang-btn]');
    if(langBtn){ var w=langBtn.closest('[data-e3c-lang]'); if(w) w.classList.toggle('is-open'); return; }
    var opt=e.target.closest('[data-e3c-locale]');
    if(opt){
      var w2=opt.closest('[data-e3c-lang]');
      var form=w2&&w2.querySelector('form');
      if(form){
        var inp=form.querySelector('input[name="locale_code"]');
        if(inp) inp.value=opt.getAttribute('data-e3c-locale');
        form.submit();
      }
      return;
    }
    document.querySelectorAll('[data-e3c-lang].is-open').forEach(function(x){x.classList.remove('is-open');});
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ closeVideo(); hideDemo(); setExpanded(false); collapseSections(); } });
  function ready(fn){ if(document.readyState!=='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);} }
  ready(function(){ initSliders(); toBody('ErasVideoModal'); toBody('ErasDemoOverlay'); toBody('ErasMobileNav'); toBody('ErasVBackdrop'); });
  document.addEventListener('shopify:section:load',function(){ initSliders(); });
})();
